// import development from './development';
// import test from './test';
// import preview from './preview';
// import production from './production';

// const configFiles = require.context('.', true, /\.js$/);
console.log('BUILD_TENANT', process.env);
const { VUE_APP_BUILD_TENANT: tenant = 'default' } = process.env;
const envConfig = require(`./${tenant}/index.js`);
console.log(`/${tenant}/index.js`, envConfig);

function setConfig(config) {
  // console.log('setConfig...');
  // const domain = window.location.host;
  // if (/^localhost/.test(domain) || /^saas.local.qq.com/.test(domain)) {
  //   config = {
  //     ...config,
  //     ...development,
  //   };
  //   return config;
  // }
  // const configs = {
  //   development,
  //   test,
  //   preview,
  //   production,
  // };
  // console.log('configs', configs);
  // for (const key in configs) {
  //   if (Object.prototype.hasOwnProperty.call(configs, key)) {
  //     const configItem = configs[key];
  //     if (configItem.domain.includes(domain)) {
  //       config = {
  //         ...config,
  //         ...configItem,
  //       };
  //       return config;
  //     }
  //   }
  // }
  const completeConfig = {
    ...config,
    ...envConfig,
  };
  return completeConfig;
}
const commonConfig = {
  apiProduct: 12,
  apiPlatform: 9,
  product: 'saas',
  company: 'tencent',
  api: '/api/access/json',
  cloud: '/api/access/pb',
  apiList: [], // 非云上接口列表
  whiteFilter: [
    'SendSmsCode',
    'Login',
    'GetManagerLoginConfig',
    'StaffLoginWithWorkwxForManager',
    'StaffLoginByOIDCForManager',
  ],
  layoutFilter: ['help', 'login', 'protocol', 'door', 'ticket'],
  rightFilter: ['help', 'login', 'protocol', 'register', 'door', 'ticket'],
};
const config = setConfig(commonConfig);
console.log('config', config);
export default config;
